function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-triangle");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-triangle",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Triangle",
  transform: "translate(15.000000, 14.250000) scale(-1, 1) translate(-15.000000, -14.250000) ",
  points: "15 5 26 23.5 4 23.5"
})));

const SvgIco30Triangle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Triangle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-triangle.6076abf0.svg";
export { ForwardRef as ReactComponent };